import { ReCaptchaProvider } from "next-recaptcha-v3";
import GoogleAnalytics from "@bradgarropy/next-google-analytics";
import App from 'next/app';
import { fetchGetCompanyGeneralData, fetchGetCompanySEO, fetchInsertPageView, fetchGetCompanySiteSettings, fetchGetCompanySubsidiaries } from "../../services/api";
import { FacebookPixel } from "../components/default/facebook-pixel";
import Script from 'next/script'

function MyApp({ Component, pageProps, seo, companyGeneralData, siteSettings }) {
  return <ReCaptchaProvider reCaptchaKey={JSON.parse(companyGeneralData).company.captchaPublicKey}>
    {
      seo && seo.googleAnalyticsId
        ? <GoogleAnalytics measurementId={seo.googleAnalyticsId} />
        : null
    }
    {
      seo && seo.facebookPixelId
        ? <FacebookPixel facebookPixelId={seo.facebookPixelId} />
        : null
    }
      <Script
        strategy="afterInteractive"
        src="https://www.googletagmanager.com/gtag/js?id=AW-17775759901"
      />

      <Script
        id="google-ads-gtag"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'AW-17775759901');
          `,
        }}
      />

    <Component {...pageProps} companyGeneralData={companyGeneralData} />
  </ReCaptchaProvider>
}

MyApp.getInitialProps = async (context) => {
  const pageProps = await App.getInitialProps(context);
  const seo = await fetchGetCompanySEO();
  const siteSettings = await fetchGetCompanySiteSettings();
  const subsidiaries = await fetchGetCompanySubsidiaries();
  const companyGeneralData = await fetchGetCompanyGeneralData();
  fetchInsertPageView({ page: context.router.asPath }).catch(err => { console.log(err.toString()) });

  return { ...pageProps, seo, companyGeneralData, siteSettings, subsidiaries };
};

export default MyApp
